import React, { useState } from "react";
import { Button, Modal, Steps, Input, Form, Result, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useStepsForm } from "sunflower-antd";

const { Step } = Steps;

interface IModalProps {
  show: boolean;
  showModal: Function;
  handleAdd: Function;
}

const AddFuneralCustomerModal: React.FC<IModalProps> = ({
  show,
  showModal,
  handleAdd,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);
      const response = await handleAdd(values);

      if (response.success) {
        setLoading(false);
        return true;
      }
      setErrorMsg(response.message);
      setLoading(false);
      return false;
    },
    total: 2,
  });

  // Step Styling
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 14 },
  };

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 14 },
  };

  const formList = [
    <>
      <Form.Item
        name="Name"
        label="Name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Name" />
      </Form.Item>
      <Form.Item
        name="Surname"
        label="Surname"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Surname" />
      </Form.Item>
      <Form.Item
        name="IdNumber"
        label="ID Number"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="ID Number" />
      </Form.Item>
      <Form.Item
        name="Cellphone"
        label="Cellphone"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Cellphone" />
      </Form.Item>
      <Form.Item
        name="AddressLine1"
        label="Address Line 1 "
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Address Line 1" />
      </Form.Item>
      <Form.Item
        name="AddressLine2"
        label="Address Line 2"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Address Line 2" />
      </Form.Item>
      <Form.Item
        name="PostalCode"
        label="Postal Code"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Postal Code" />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            style={{ marginBottom: 10 }}
            block
            size="large"
            loading={formLoading}
            onClick={() => {
              submit().then((result) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="New Customer"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={600}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 600 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button
                  loading={loading}
                  block
                  size="large"
                  onClick={handleModal}
                >
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button
                  loading={loading}
                  block
                  size="large"
                  onClick={handleModal}
                >
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddFuneralCustomerModal;
